const parse = require('./parse')
const clean = (version, options) => {
  const s = parse(version.trim().replace(/^[=v]+/, ''), options)
  return s ? s.version : null
}
module.exports = clean



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/clean.js
// module id = 2182
// module chunks = 0